export const phoneNumbers = [
  { label: "+03 666 6868", href: "tel:+6036666868" },
  { label: "+60 12 345 6789", href: "tel:+60123456789" },
];

export const socialLinks = [
  { label: "Facebook", icon: "ri:facebook-fill", href: "https://facebook.com" },
  { label: "X", icon: "ri:twitter-x-fill", href: "https://x.com" },
  { label: "Instagram", icon: "ri:instagram-line", href: "https://instagram.com" },
  { label: "YouTube", icon: "ri:youtube-fill", href: "https://youtube.com" },
  { label: "LinkedIn", icon: "ri:linkedin-fill", href: "https://linkedin.com" },
];
